/**
 * School theme — applies primary / secondary colours from settings.school.theme
 * by overriding CSS custom properties on :root.
 *
 * Theme shape (in /settings/school):
 *   theme: { primary: '#2a7d7d', secondary: '#1e293b' }
 *
 * From the primary, we derive `primary-light` (very pale tint) and
 * `primary-dark` (shadow tint) so the existing styles all rebrand at once.
 */

function clamp(n) { return Math.max(0, Math.min(255, Math.round(n))); }

function hexToRgb(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
  if (!m) return null;
  return { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) };
}
function rgbToHex(r, g, b) {
  return '#' + [r, g, b].map(v => clamp(v).toString(16).padStart(2, '0')).join('');
}
function lighten(hex, amount) {
  const c = hexToRgb(hex); if (!c) return hex;
  return rgbToHex(c.r + (255 - c.r) * amount, c.g + (255 - c.g) * amount, c.b + (255 - c.b) * amount);
}
function darken(hex, amount) {
  const c = hexToRgb(hex); if (!c) return hex;
  return rgbToHex(c.r * (1 - amount), c.g * (1 - amount), c.b * (1 - amount));
}

export function applyTheme(theme = {}) {
  const root = document.documentElement;
  const primary = theme.primary || '#2a7d7d';
  const secondary = theme.secondary || '#1e293b';
  root.style.setProperty('--clr-primary', primary);
  root.style.setProperty('--clr-primary-light', lighten(primary, 0.85));
  root.style.setProperty('--clr-primary-dark', darken(primary, 0.25));
  root.style.setProperty('--clr-navy', secondary);
  root.style.setProperty('--clr-navy-light', lighten(secondary, 0.25));
}

export function clearTheme() {
  const root = document.documentElement;
  ['--clr-primary', '--clr-primary-light', '--clr-primary-dark', '--clr-navy', '--clr-navy-light']
    .forEach(v => root.style.removeProperty(v));
}
